import "./styles.scss";

import { API, Endpoints } from "utils/api";
import { Col, ConfigProvider, Drawer, Input, Modal, Pagination, Row, Select, Switch, Table, notification } from "antd";
import { Icons, PhoneInput } from "components";
import { setBreadcrumb, setLoader } from "store/actions";

import Dropzone from "react-dropzone";
import { Footer } from "screens";
import { Helmet } from "react-helmet";
import React from "react";
import Strings from "utils/strings";
import UserPlaceholder from "assets/images/placeholders/user2x.jpg";
import { connect } from "react-redux";
import en from "antd/es/locale/en_GB";
import pt from "antd/es/locale/pt_PT";

class Coworkers extends React.Component<any, any> {
	constructor(props: any) {
		super(props);

		this.state = {
			userId: props.user._id,
			coworkers: [],
			viewUserStatus: true,
			loading: true,
			page: 1,
			pageSize: 10,
			showUploadModal: false,
			showResendEmailModal: false,
			group: null,
			invalidUsers: [],
			searchText: "",
			viewInactiveUsers: false
		};
	}

	componentDidMount() {
		const { dispatch } = this.props;

		dispatch(
			setBreadcrumb(() => ({
				locations: [
					{
						text: Strings.sidebar.coworkers,
						route: "/coworkers"
					}
				]
			}))
		);

		this.getData();
	}

	async getData() {
		this.setState({ loading: true });

		let response: any;
		try {
			response = await API.get({
				url: Endpoints.uriBusinessUsers()
			});

			if (response.ok) {
				this.setState({
					coworkers: response.data.results?.users || [],
					business: response.data.results?.business
				});
			} else {
				notification.error({
					message: Strings.sidebar.coworkers,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.sidebar.coworkers,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		this.setState({ loading: false });
	}

	renderBadge(isConfirmed: boolean) {
		if (isConfirmed) {
			return <span className="TableTag --tag-green">Confirmado</span>;
		}

		return <span className="TableTag --tag-orange">Pendente</span>;
	}

	humanFileSize(bytes: number, si = false, dp = 1) {
		const thresh = si ? 1000 : 1024;

		if (Math.abs(bytes) < thresh) {
			return bytes + " B";
		}

		const units = si
			? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
			: ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
		let u = -1;
		const r = 10 ** dp;

		do {
			bytes /= thresh;
			++u;
		} while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);

		return bytes.toFixed(dp) + " " + units[u];
	}

	async uploadFile() {
		const { file, group, disableModal } = this.state;
		const { dispatch } = this.props;

		const data = new FormData();
		data.append("files", file);
		data.append("group", group);
		data.append("disable", disableModal || false);

		dispatch(setLoader(true));

		let response: any;
		try {
			response = await API.post({
				url: Endpoints.uriImportUsers(),
				data
			});

			if (response.ok) {
				const { users = [], invalidUsers = [] } = response.data.results || {};
				const showInvalidUsersModal = invalidUsers.length > 0 ? true : false;
				this.setState({
					coworkers: users,
					invalidUsers,
					showInvalidUsersModal,
					showUploadModal: false,
					disableModal: false
				});

				notification.success({
					message: Strings.coworkers.upload,
					description:
						invalidUsers.length > 0 ? Strings.coworkers.importedWithErrors : Strings.coworkers.imported,
					placement: "bottomRight",
					duration: 5
				});
			} else {
				notification.error({
					message: Strings.coworkers.upload,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.coworkers.upload,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	renderUploadModal() {
		const { showUploadModal, disableModal, file, business, group } = this.state;
		const { mobile } = this.props;
		let size: any;

		if (file) {
			size = this.humanFileSize(file.size, true);
		}

		return (
			<Modal
				centered={true}
				closable={true}
				onCancel={() => this.setState({ showUploadModal: false, disableModal: false })}
				visible={showUploadModal}
				footer={null}
				className="CoworkersModalNoPadding"
				width={mobile ? "100%" : 600}
			>
				<div className="UploadModal">
					<div className="UploadTitle">
						<p>{disableModal ? Strings.coworkers.uploadDisable : Strings.coworkers.upload}</p>
					</div>
					<div className="UploadBody">
						<Dropzone
							className="UploadDropzone"
							id="upload_file"
							multiple={false}
							accept="text/csv, .xls, .xlsx"
							onDrop={(files: any) => this.setState({ file: files[0] })}
						>
							{file ? (
								<React.Fragment>
									<p>Name: {file?.name}</p>
									<p>Size: {size}</p>
								</React.Fragment>
							) : (
								<React.Fragment>
									<Icons.UploadFile />
									<p>{Strings.generic.uploadFile}</p>
								</React.Fragment>
							)}
						</Dropzone>
					</div>
					{business?.businessGroups && (
						<div className="UploadGroup">
							<Select
								id="employee_role"
								className="tagsSelector CoworkersSelectFullWidth"
								placeholder={Strings.coworkers.group}
								showSearch
								allowClear
								filterOption={(input: any, option: any) =>
									option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
								}
								value={group || null}
								onChange={(elem: any) => this.setState({ group: elem })}
							>
								{business?.groups?.map((group: any) => (
									<Select.Option key={`group_${group?._id}`} value={group._id}>
										{group.name}
									</Select.Option>
								))}
							</Select>
						</div>
					)}
					<div className="UploadFooter">
						{!disableModal && (
							<form
								method="get"
								action="https://team24-storage.s3.eu-west-3.amazonaws.com/assets/importUsers.xlsx"
							>
								<button className="DownloadButton" onClick={() => {}}>
									{Strings.coworkers.download}
								</button>
							</form>
						)}
						{disableModal && (
							<form
								method="get"
								action="https://team24-storage.s3.eu-west-3.amazonaws.com/assets/importDisableUsers.xlsx"
							>
								<button className="DownloadButton" onClick={() => {}}>
									{Strings.coworkers.download}
								</button>
							</form>
						)}
						<button className="ImportButton" onClick={() => this.uploadFile()} disabled={!file}>
							{Strings.coworkers.import}
						</button>
					</div>
				</div>
			</Modal>
		);
	}

	renderInvalidUsersModal() {
		const { showInvalidUsersModal, invalidUsers } = this.state;
		const { mobile } = this.props;

		return (
			<Modal
				centered={true}
				closable={true}
				onCancel={() => this.setState({ showInvalidUsersModal: false, invalidUsers: [], group: null })}
				visible={showInvalidUsersModal}
				footer={null}
				className="CoworkersModalNoPadding"
				width={mobile ? "100%" : 800}
			>
				<div className="UploadModal">
					<div className="UploadTitle">
						<p>{Strings.coworkers.importedErrors}</p>
					</div>
					<div className="UploadBody --boxed">
						<div className="UploadHeaders">
							<p>{Strings.fields.name}</p>
							<p>{Strings.authentication.email}</p>
							<p>{Strings.fields.error}</p>
						</div>
						<div className="UploadErrorList">
							{invalidUsers.map((user: any, index: number) => (
								<div key={`invalid_user_${index}`} className="InvalidUserEntry">
									<p>{user.Name}</p>
									<p>{user.Email}</p>
									<p>{user.error}</p>
								</div>
							))}
						</div>
					</div>
					<div className="UploadFooter">
						<button
							className="DownloadButton"
							onClick={() => this.setState({ showInvalidUsersModal: false, invalidUsers: [] })}
						>
							{Strings.generic.confirm}
						</button>
					</div>
				</div>
			</Modal>
		);
	}

	renderResendEmailModal() {
		const { showResendEmailModal } = this.state;

		return (
			<Modal
				centered={true}
				closable={true}
				onCancel={() => this.setState({ showResendEmailModal: false })}
				visible={showResendEmailModal}
				footer={null}
				className="CoworkersModalNoPadding"
				width={600}
			>
				<div className="UploadModal">
					<div className="UploadTitle">
						<p>{Strings.coworkers.resendInvite}</p>
					</div>
					<div className="UploadBody">
						<p>{Strings.coworkers.areYouSure}</p>
					</div>
					<div className="UploadFooter">
						<button className="ImportButton" onClick={() => this.setState({ showResendEmailModal: false })}>
							{Strings.appointments.cancel}
						</button>
						<button className="DownloadButton" onClick={() => this.resendBusinessInvites()}>
							{Strings.contactUs.send}
						</button>
					</div>
				</div>
			</Modal>
		);
	}

	async deleteUser(user: any) {
		const { dispatch } = this.props;

		dispatch(setLoader(true));

		let response: any;
		try {
			response = await API.delete({
				url: Endpoints.uriBusinessUsers(user._id)
			});

			if (response.ok) {
				await this.getData();

				notification.success({
					message: Strings.sidebar.coworkers,
					description: Strings.coworkers.deleted,
					placement: "bottomRight",
					duration: 5
				});
			} else {
				notification.error({
					message: Strings.sidebar.coworkers,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.sidebar.coworkers,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	async submitUser() {
		const { tempUser } = this.state;
		const { dispatch } = this.props;

		const body = { ...tempUser };
		delete body._id;

		dispatch(setLoader(true));

		let response: any;
		try {
			const request = tempUser?._id ? API.put : API.post;
			response = await request({
				url: Endpoints.uriBusinessUsers(tempUser?._id || ""),
				data: body
			});

			if (response.ok) {
				await this.getData();

				notification.success({
					message: Strings.sidebar.coworkers,
					description: tempUser?._id ? Strings.coworkers.edited : Strings.coworkers.added,
					placement: "bottomRight",
					duration: 5
				});

				this.setState({ showDrawer: false, tempUser: null });
			} else {
				notification.error({
					message: Strings.sidebar.coworkers,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.sidebar.coworkers,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	async resendBusinessInvites() {
		const { dispatch } = this.props;
		const { business } = this.state;

		dispatch(setLoader(true));

		let response: any;
		try {
			response = await API.post({
				url: Endpoints.uriBusinessResentInvitation(),
				data: {
					business: business._id
				}
			});

			if (response.ok) {
				notification.success({
					message: Strings.sidebar.coworkers,
					description: Strings.coworkers.resendBusinessEmailSuccess,
					placement: "bottomRight",
					duration: 5
				});
			} else {
				notification.error({
					message: Strings.sidebar.coworkers,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.sidebar.coworkers,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		this.setState({
			showResendEmailModal: false
		});

		dispatch(setLoader(false));
	}

	async onToggle(row: any, user: any) {
		const { dispatch } = this.props;

		dispatch(setLoader(true));

		let response: any;
		try {
			response = await API.patch({
				url: Endpoints.uriBusinessUsers(user._id),
				data: {
					isActive: !row.isActive
				}
			});

			if (response.ok) {
				await this.getData();

				notification.success({
					message: Strings.sidebar.coworkers,
					description: Strings.coworkers.edited,
					placement: "bottomRight",
					duration: 5
				});
			} else {
				notification.error({
					message: Strings.sidebar.coworkers,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.sidebar.coworkers,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	renderDrawerContent() {
		const { tempUser, userId, business } = this.state;

		return (
			<Row gutter={[0, 20]}>
				<Col xs={24}>
					<label htmlFor="employee_name" className="InputLabel --label-required">
						{Strings.fields.name}
					</label>
					<Input
						id="employee_name"
						value={tempUser?.name || ""}
						className="ProfileInput"
						required
						disabled={tempUser?._id}
						placeholder={Strings.fields.name}
						onChange={(e: any) => {
							const value = e.target.value;

							this.setState((prevState: any) => ({
								tempUser: { ...prevState.tempUser, name: value }
							}));
						}}
					/>
				</Col>
				<Col xs={24}>
					<label htmlFor="employee_email" className="InputLabel --label-required">
						{Strings.authentication.email}
					</label>
					<Input
						id="employee_email"
						value={tempUser?.email || ""}
						className="ProfileInput"
						type="email"
						required
						disabled={tempUser?._id}
						placeholder={Strings.authentication.email}
						onChange={(e: any) => {
							const value = e.target.value;

							this.setState((prevState: any) => ({
								tempUser: { ...prevState.tempUser, email: value }
							}));
						}}
					/>
				</Col>
				<Col xs={24}>
					<label htmlFor="employee_number" className="InputLabel">
						{Strings.coworkers.number}
					</label>
					<Input
						id="employee_number"
						value={tempUser?.userNumber || ""}
						className="ProfileInput"
						type="email"
						required
						placeholder={Strings.coworkers.number}
						onChange={(e: any) => {
							const value = e.target.value;

							this.setState((prevState: any) => ({
								tempUser: { ...prevState.tempUser, userNumber: value }
							}));
						}}
					/>
				</Col>
				<Col xs={24}>
					<label htmlFor="employee_phone" className="InputLabel">
						{Strings.profile.phone}
					</label>
					<PhoneInput
						id="employee_phone"
						containerClass={`${tempUser?._id ? "react-tel-input --phone-disabled" : "react-tel-input"} CoworkersPhoneInput`}
						defaultCountry="pt"
						value={tempUser?.phone || ""}
						disabled={Boolean(tempUser?._id)}
						onChange={(phone: any) => {
							this.setState((prevState: any) => ({
								tempUser: { ...prevState.tempUser, phone }
							}));
						}}
					/>
				</Col>
				<Col xs={24}>
					<label htmlFor="employee_role" className="InputLabel">
						{Strings.sidebar.profile}
					</label>
					<Select
						id="employee_role"
						className="tagsSelector CoworkersSelectFullWidth"
						placeholder={Strings.placeholders.role}
						showSearch
						filterOption={(input: any, option: any) =>
							option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
						}
						value={tempUser?.role || null}
						disabled={tempUser?._id === userId}
						onChange={(elem: any) =>
							this.setState((state: any) => ({
								tempUser: { ...state.tempUser, role: elem }
							}))
						}
					>
						<Select.Option value="user">{Strings.coworkers.roleUser}</Select.Option>
						<Select.Option value="hr">{Strings.coworkers.roleHr}</Select.Option>
					</Select>
				</Col>
				{business?.businessGroups && (
					<Col xs={24}>
						<label htmlFor="drawer_user" className="GenericLabel --label-required">
							{Strings.coworkers.group}
						</label>
						<Select
							id="employee_role"
							className="tagsSelector CoworkersSelectFullWidth"
							placeholder={Strings.coworkers.group}
							showSearch
							filterOption={(input: any, option: any) =>
								option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
							}
							value={tempUser?.group || null}
							disabled={tempUser?._id === userId}
							onChange={(elem: any) => {
								this.setState((state: any) => ({
									tempUser: { ...state.tempUser, group: elem }
								}));
							}}
						>
							{business?.groups?.map((group: any) => (
								<Select.Option key={`group_${group?._id}`} value={group._id}>
									{group.name}
								</Select.Option>
							))}
						</Select>
					</Col>
				)}
			</Row>
		);
	}

	renderDrawer() {
		const { showDrawer, tempUser } = this.state;
		const { mobile } = this.props;

		return (
			<Drawer
				title={
					<h2 className="DrawerTitle">{tempUser?._id ? Strings.coworkers.edit : Strings.coworkers.add}</h2>
				}
				footer={
					<div className="DrawerFooter">
						<button
							className="DrawerFooterButton"
							onClick={() =>
								this.setState({
									tempUser: null,
									showDrawer: false
								})
							}
						>
							{Strings.appointments.cancel}
						</button>
						<button className="DrawerFooterButton --btn-primary" onClick={() => this.submitUser()}>
							{Strings.appointments.confirm}
						</button>
					</div>
				}
				className="drawer"
				width={mobile ? "100%" : 400}
				placement="right"
				closable={true}
				visible={showDrawer}
				onClose={() => this.setState({ showDrawer: false, tempUser: null })}
			>
				{this.renderDrawerContent()}
			</Drawer>
		);
	}

	render() {
		const { coworkers, loading, page, pageSize, searchText, business, viewInactiveUsers } = this.state;
		const { language, mobile } = this.props;

		return (
			<React.Fragment>
				<Helmet>
					<title>{Strings.sidebar.coworkers} | Team24</title>
					<meta name="description" content="Description of Coworkers" />
				</Helmet>
				<div className="CoworkersContent">
					<div className="MultiTitle">
						<h1>{Strings.sidebar.coworkers}</h1>
						{!mobile && (
							<div className="TableHeaderActions">
								<Input.Search
									id="table_search"
									value={searchText || ""}
									className="TableSearchInput"
									enterButton
									placeholder={Strings.generic.search}
									onChange={(e: any) => {
										this.setState({ searchText: e.target.value });
									}}
								/>
							</div>
						)}
					</div>
					{mobile && (
						<div className="TableHeaderActions">
							<Input.Search
								id="table_search"
								value={searchText || ""}
								className="TableSearchInput"
								enterButton
								placeholder={Strings.generic.search}
								onChange={(e: any) => {
									this.setState({ searchText: e.target.value });
								}}
							/>
							<button onClick={() => this.setState({ showUploadModal: true })}>
								<Icons.Upload />
							</button>
							<button onClick={() => this.setState({ showDrawer: true, tempUser: { role: "user" } })}>
								<Icons.Plus />
							</button>
						</div>
					)}
					<div className="TableHeaderActions">
						<button onClick={() => this.setState({ showUploadModal: true, disableModal: false })}>
							<Icons.Upload />
							<p>{Strings.coworkers.upload}</p>
						</button>
						<button onClick={() => this.setState({ showUploadModal: true, disableModal: true })}>
							<Icons.Upload />
							<p>{Strings.coworkers.uploadDisable}</p>
						</button>
						<button onClick={() => this.setState({ showDrawer: true, tempUser: { role: "user" } })}>
							<Icons.Plus />
							<p>{Strings.coworkers.add}</p>
						</button>
						<button
							className="DrawerFooterButton --btn-primary"
							onClick={() =>
								this.setState({
									showResendEmailModal: true
								})
							}
						>
							{Strings.coworkers.resendInvite}
						</button>
						<div>
							<span className="InactiveUsersLabel">{Strings.coworkers.innactiveUsers}</span>
							<Switch
								size="small"
								checked={viewInactiveUsers}
								onChange={() =>
									this.setState({
										viewInactiveUsers: !viewInactiveUsers
									})
								}
							/>
						</div>
					</div>
					<div className="CoworkersDivision">
						<ConfigProvider locale={language === "pt" ? pt : en}>
							<Table
								dataSource={coworkers
									.filter((entry: any) => (viewInactiveUsers ? true : entry.isActive))
									.filter(
										(entry: any) =>
											entry.user?.name
												?.toLowerCase()
												.includes(searchText?.trim().toLowerCase()) ||
											entry.user?.email
												?.toLowerCase()
												.includes(searchText?.trim().toLowerCase()) ||
											entry.user?.phone
												?.toLowerCase()
												.includes(searchText?.trim().toLowerCase()) ||
											entry.userNumber
												?.toLowerCase()
												.includes(searchText?.trim().toLowerCase()) ||
											entry.group?.name?.toLowerCase().includes(searchText?.trim().toLowerCase())
									)
									.slice(0 + pageSize * (page - 1), pageSize + pageSize * (page - 1))}
								columns={[
									{
										title: "",
										dataIndex: "user",
										render: (value: any) => (
											<img src={value?.photo || UserPlaceholder} alt="avatar" />
										),
										width: 70
									},
									{
										title: Strings.coworkers.number,
										dataIndex: "userNumber",
										render: (value: any) => <p>{value || "-"}</p>,
										width: 150
									},
									{
										title: Strings.fields.name,
										dataIndex: "user",
										render: (value: any) => <p>{value?.name}</p>
									},
									{
										title: Strings.authentication.email,
										dataIndex: "user",
										render: (value: any) => <p>{value?.email}</p>
									},
									{
										title: Strings.profile.phone,
										dataIndex: "user",
										render: (value: any) => <p>{value?.phone || "-"}</p>,
										width: 150
									},
									...(business?.businessGroups
										? [
												{
													title: Strings.coworkers.group,
													dataIndex: "group",
													render: (value: any) => <p>{value?.name || "-"}</p>,
													width: 150
												}
										  ]
										: []),
									...(business?.viewUserStatus
										? [
												{
													title: Strings.coworkers.status,
													dataIndex: "user",
													render: (value: any) => this.renderBadge(value?.isConfirmed),
													width: 120
												}
										  ]
										: []),
									{
										title: Strings.fields.actions,
										align: "right",
										dataIndex: "user",
										render: (user: any, row: any) => (
											<div className="TableActions">
												<button
													onClick={() => {
														this.setState({
															tempUser: {
																...JSON.parse(JSON.stringify(user)),
																userNumber: row.userNumber,
																role: row.role,
																group: row.group?._id
															},
															showDrawer: true
														});
													}}
												>
													<Icons.Pencil2 />
												</button>
												{/* <Popconfirm
													title={Strings.generic.areYouSure}
													okText={Strings.generic.delete}
													cancelText={Strings.appointments.cancel}
													okType="danger"
													placement="topRight"
													disabled={user?._id === userId}
													onConfirm={() => this.deleteUser(user)}
													onCancel={(e: any) => e.stopPropagation()}
												>
													<button>
														<Icons.Bin />
													</button>
												</Popconfirm> */}

												<Switch
													size="small"
													checked={row?.isActive}
													onChange={() => this.onToggle(row, user)}
												/>
											</div>
										),
										width: 100
									}
								]}
								rowKey={(row: any) => `row_${row._id}`}
								pagination={false}
								size="middle"
								loading={loading}
								className="CoworkersTable"
								sticky
							/>
						</ConfigProvider>
						<div className="CoworkersPagination">
							<Pagination
								total={coworkers.filter((entry: any) => (viewInactiveUsers ? true : entry.isActive)).length}
								current={page}
								pageSize={pageSize}
								onChange={(value: any) => this.setState({ page: value })}
								showSizeChanger
								onShowSizeChange={(current: any, size: any) => this.setState({ pageSize: size })}
							/>
						</div>
					</div>
				</div>
				{mobile && <Footer />}
				{this.renderUploadModal()}
				{this.renderInvalidUsersModal()}
				{this.renderDrawer()}
				{this.renderResendEmailModal()}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: any) => ({
	language: state.language,
	mobile: state.mobile,
	user: state.user
});

export default connect(mapStateToProps)(Coworkers);
